import {
    SAVE_APPLICANT_BANKER_ADJUSTMENT,
    GET_APPLICANT_BANKER_ADJUSTMENTS_BY_APPLICATION_ID,
    GET_APPLICANT_BANKER_ADJUSTMENT_HISTORY,
} from "../constants/constants";
import { instance } from "./apiRequest";

// Banker/Underwriter Adjustment feature (BankerAdjustmentExecutionPlan.md Section 8.1).
// Kept as its own module -- same convention as ChangeHistoryService.js -- rather than added to
// the already-large NewapplicationService.js, since this isn't part of the applicant's own
// submission flow.
let _ApplicantBankerAdjustmentService = {
    async saveAdjustment({ applicationId, screenModule, tableName, fieldName, sourceRowId = null, adjustedValue, reason }) {
        return await instance.post(SAVE_APPLICANT_BANKER_ADJUSTMENT, {
            ApplicationId: applicationId,
            ScreenModule: screenModule,
            TableName: tableName,
            FieldName: fieldName,
            SourceRowId: sourceRowId,
            AdjustedValue: adjustedValue,
            Reason: reason,
        });
    },
    async getAdjustmentsByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_BANKER_ADJUSTMENTS_BY_APPLICATION_ID, { ApplicationId: applicationId });
    },
    async getAdjustmentHistory({ applicationId, tableName, fieldName, sourceRowId = null }) {
        return await instance.post(GET_APPLICANT_BANKER_ADJUSTMENT_HISTORY, {
            ApplicationId: applicationId,
            TableName: tableName,
            FieldName: fieldName,
            SourceRowId: sourceRowId,
        });
    },
};

export default _ApplicantBankerAdjustmentService;
